import { Fetcher } from "react-router-dom";
import { DecimalResult } from "../../../../common/api/decimal/utils.ts";
import { ManageAsset } from "../../../../common/api/decimal/common-types/manageAssets.ts";

function hasError(fetchers: Fetcher<DecimalResult<unknown>>[]) {
  return fetchers.some((fetcher) => fetcher.data && !fetcher.data?.ok);
}

export default function usePaginatedAssetFetcherStatus(
  fetchers: Fetcher<DecimalResult<ManageAsset[]>>[]
) {
  function getLoadStatus() {
    if (
      fetchers.some(
        (fetcher) =>
          !fetcher.data &&
          (fetcher.state === "loading" || fetcher.state === "idle")
      )
    ) {
      // Loading a page for the first time. Does not flip back to loading on revalidate.
      return "loading";
    }
    if (hasError(fetchers)) {
      return "error";
    }
    return "waiting";
  }

  function getPaginationStatus() {
    if (hasError(fetchers)) {
      return "error";
    }
    // Only updates when the load completes. May need revision at some point
    if (
      fetchers.some(
        (fetcher) =>
          fetcher.data?.meta?.page?.pages !== undefined &&
          fetcher.data?.meta?.page?.pages.last ===
            fetcher.data?.meta?.page?.pages.current
      )
    ) {
      return "all-pages-loaded";
    }
    if (fetchers.some((fetcher) => fetcher.data && fetcher.data.ok)) {
      return "has-more-pages";
    }
    return "waiting";
  }

  function getContentLengthStatus() {
    if (fetchers.length === 1 && fetchers[0].data?.data?.length === 0) {
      return "empty";
    }
    if (
      fetchers.some(
        (fetcher) => fetcher.data?.data && fetcher.data.data.length > 0
      )
    ) {
      return "has-content";
    }
    return "waiting";
  }

  return {
    loadStatus: getLoadStatus(),
    paginationStatus: getPaginationStatus(),
    contentLengthStatus: getContentLengthStatus(),
  };
}
